import React, { Component } from 'react';
import Select, { components } from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import { ArrowDropDown } from '@material-ui/icons';
import { Typography, TextField, MenuItem, Paper } from '@material-ui/core';

const AutoCompleteStyle = theme => ({
  root: {
    marginTop: 16
  },
  input: {
    display: 'flex',
    padding: 0,
    height: 32,
    width: 190,
    '& div:nth-child(1)': {
      paddingLeft: 0
    },
    '& div:nth-child(2)': {
      '& div': {
        padding: '8px 2px',
        '& svg': {
          color: 'rgba(0, 0, 0, 0.54)'
        }
      }
    }
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
  },
  singleValue: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 16
  },
  option: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.14)'
    }
  },
  paper: {
    display: 'block',
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    transition:
      'opacity 255ms cubic-bezier(0.4, 0, 0.2, 1) 2000ms, transform 170ms cubic-bezier(0.4, 0, 0.2, 1) 2000ms',
    zIndex: 1
  },
  selectContainer: {
    display: 'block !important'
  },
  muiSvgIcon: {
    content: ''
  }
});

const NoOptionsMessage = props => {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
};

const inputComponent = ({ inputRef, ...props }) => {
  return <div ref={inputRef} {...props} />;
};

const Control = props => {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps
        }
      }}
    />
  );
};

const Option = props => {
  return (
    <MenuItem
      className={props.selectProps.classes.option}
      buttonRef={props.innerRef}
      selected={props.isSelected}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
};

const SingleValue = props => {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
};

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <ArrowDropDown className="AutoComplete-MuiSvgIcon" />
    </components.DropdownIndicator>
  );
};

const Menu = props => {
  return (
    <Paper
      square
      className={props.selectProps.classes.paper}
      {...props.innerProps}
    >
      {props.children}
    </Paper>
  );
};

const theComponents = {
  Control,
  Menu,
  DropdownIndicator,
  NoOptionsMessage,
  Option,
  SingleValue,
  IndicatorSeparator: null
};

const AutoComplete = class extends Component {
  render() {
    const { classes, value } = this.props;
    const styles = {};

    return (
      <div className={classes.root}>
        <Select
          {...this.props}
          styles={styles}
          components={theComponents}
          tabSelectsValue={false}
          name={`${value}AutoComplete`}
          placeholder=""
        />
      </div>
    );
  }
};

export default withStyles(AutoCompleteStyle)(AutoComplete);



// WEBPACK FOOTER //
// ./src/components/layout/AutoComplete.js